import shortId from "shortid";

import {CartItem} from "./types";

import {ClientTenant, Field} from "~/tenant/types";
import {formatPrice} from "~/i18n/selectors";

export function getTotal(items: CartItem[]): number {
  return items.reduce((total, item) => total + getPrice(item), 0);
}

export function getPrice(item: CartItem): number {
  switch (item.product.type) {
    // Price should not be modified
    case "hidden":
    case "unavailable":
    case "ask": {
      return 0;
    }

    // Sum total and variants
    default: {
      return item.product.price * item.count;
    }
  }
}

export function getFormattedPrice(item: CartItem): string {
  switch (item.product.type) {
    // This should never be shown
    case "hidden": {
      return "No disponible";
    }

    // No stock
    case "unavailable": {
      return "Sin stock";
    }

    // Ask price
    case "ask": {
      return "A consultar";
    }

    // Get price
    default: {
      return formatPrice(getPrice(item));
    }
  }
}

export function getCount(items: CartItem[]): number {
  return items.reduce((total, item) => total + item.count, 0);
}

function _getFields(fields: Field[]) {
  if (!fields) return "";

  return fields
    .filter(({title, value}) => title && value)
    .map(({title, value}) => `${title}: *${value}*`)
    .join("\n");
}

function _getItems(items: CartItem[]): string {
  return items
    .map(
      (item) =>
        `— ${[
          item.count > 1 ? `*[ ${item.count} ]*` : "",
          item.product.title,
          item.note ? `(${item.note})` : "",
          `> *${getFormattedPrice(item)}*`,
        ]
          .filter(Boolean)
          .join(" ")}`,
    )
    .join("\n");
}

export function getMessage(items: CartItem[], orderId: string, fields?: Field[]): string {
  return (
    `PEDIDO: *${orderId}*` +
    "\n\n" +
    _getItems(items) +
    "\n\n" +
    `*Total: ${formatPrice(getTotal(items))}*` +
    (fields ? "\n\n" + _getFields(fields) : "")
  );
}

export const getOrderId = (id: ClientTenant["id"]) => {
  // Set characters
  shortId.characters("0123456789abcdefghijklmnñopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZÑ");

  // Generate order id
  return `${id.slice(0, 3).toUpperCase()}-${shortId.generate().slice(0, 5).toUpperCase()}`;
};
